<template>
	<header class="eb-header" :class="{'eb-internal-header': $route.path !== '/accueil' && (isMobile || isSmallScreen)}">
		<!--
		<div v-if="$route.path == '/accueil' ||  ($route.path !== '/accueil' && (!isMobile && !isSmallScreen))" class="eb-header-help">
			<router-link :to="{name: 'aide'}"><font-awesome-icon :icon="['far', 'question-circle']" size="lg" /><span class="sr-only">Aide</span></router-link>
		</div>
		-->
		
		<div v-if="user && ($route.path == '/accueil' ||  ($route.path !== '/accueil' && (!isMobile && !isSmallScreen)))" class="eb-header-main">
			<router-link :to="{name: 'monCompte'}" class="eb-avatar">
				<font-awesome-icon :icon="['fas', 'user-circle']" size="lg" />
				Mon compte : {{ user.nom }} {{ user.prenom }}
			</router-link>
		</div>

		<div v-if="$route.path !== '/accueil' && (isMobile || isSmallScreen)" class="flex align-items-center">
			<EbButton hierarchy="text" withIcon="icon-only" @click="$router.go(-1)">
				<font-awesome-icon :icon="['fas', 'chevron-left']" size="lg" />
				<span class="sr-only">Retour</span>
			</EbButton>
			<EbHeading level="h1" class="eb-page-heading">{{ $route.meta.title }}</EbHeading>
		</div>

		<div class="eb-header-logout">
			<router-link :to="{name: 'logout'}" class="eb-logout" title="Se déconnecter">
				<font-awesome-icon :icon="['fas', 'sign-out-alt']" size="2x" /><span class="sr-only">Se déconnecter</span>
			</router-link>
		</div>
	</header>
</template>

<script>
export default {
	name: "headerGeneral",
	data() {
		return {
			user: null,
		}
	},
	mounted() {
		if (this.$store.getters.isAuthenticated) {
			this.user = this.$store.getters.StateUser
		}
		if (window.screen.width < 768) {
			this.isSmallScreen = true
		}
	},
}
</script>
